module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-07.3b820cfa.png";